/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import * as LearningLoopApi from '../../api/LearningLoop'
import {ACTION_TYPES} from "./LearningLoopConst";
import {isClosedState} from "../../faults/common/FaultsConst";
import * as Airtime from "../../api/Airtime";

export const REQUEST_LEARNING_LOOP_PACKETS = 'REQUEST_LEARNING_LOOP_PACKETS'
export const RECEIVE_LEARNING_LOOP_PACKETS = 'RECEIVE_LEARNING_LOOP_PACKETS'

export const REQUEST_NOT_EXPORTED_LEARNING_LOOP_PACKETS_COUNT = 'REQUEST_NOT_EXPORTED_LEARNING_LOOP_PACKETS_COUNT'
export const RECEIVE_NOT_EXPORTED_LEARNING_LOOP_PACKETS_COUNT = 'RECEIVE_NOT_EXPORTED_LEARNING_LOOP_PACKETS_COUNT'

export const EXPORT_LEARNING_LOOP_PACKETS = 'EXPORT_LEARNING_LOOP_PACKETS'
export const RECEIVE_GENERAL = 'RECEIVE_GENERAL'
export const CLEAR_STATE = 'CLEAR_STATE'
export const FILTER_CHANGED = 'FILTER_CHANGED'
export const ASK_FOR_PASSWORD = 'ASK_FOR_PASSWORD'

export const fetchLearningLoopPackets = (ldiId, filter) => dispatch => {
    dispatch(requestLearningLoopPackets());
    return LearningLoopApi.fetchLearningLoopPackets(ldiId, filter).then(
        function (response) {
            dispatch(receiveLearningLoopPackets(response));
        }
    ).catch(() => {
        dispatch(receiveGeneral());
    })
}

export const countNotExportedLearningLoopPackets = (ldiId) => dispatch => {
    dispatch(requestNotExportedLearningLoopPacketsCount());
    return LearningLoopApi.countLearningLoopPackets(ldiId, {exportedStates: [ACTION_TYPES.NOT_EXPORTED]}).then(
        function (response) {
            dispatch(receiveNotExportedLearningLoopPacketsCount(response));
        }
    ).catch(() => {
        dispatch(receiveGeneral());
    })
}

export const exportLearningLoopPacket = (ldiId) => dispatch => {
    dispatch(exportLearningLoopPackets());
    return LearningLoopApi.exportLearningLoopPacket(ldiId).then((response) => {
            dispatch(receiveGeneral())
            return (response);
        }
    ).catch((err) => {
        // there will be different behaviour for these three types of error - display modal and request for password
        if (err && err.generalError === false && err.errorKey && (
            err.errorKey.indexOf('KMS_CONNECTOR_TOKEN_EMPTY') !== -1 ||
            err.errorKey.indexOf('KMS_CONNECTOR_TOKEN_INVALID') !== -1 ||
            err.errorKey.indexOf('KMS_CONNECTOR_REFUSED') !== -1
        )
        ) {
            dispatch(askForPassword());
        } else {
            err = {...err, showErrorNotification: true};
            dispatch(receiveGeneral());
        }
        throw err;
    })
}

export const filterChanged = (filter) => dispatch => {
    dispatch(filterChangedType(filter))
}

const filterChangedType = (filter) => {
    return {
        type: FILTER_CHANGED,
        filter: filter,
    }
}

const requestLearningLoopPackets = () => {
    return {
        type: REQUEST_LEARNING_LOOP_PACKETS,
    }
}

const exportLearningLoopPackets = () => {
    return {
        type: EXPORT_LEARNING_LOOP_PACKETS,
    }
}

const receiveLearningLoopPackets = (data) => {
    return {
        type: RECEIVE_LEARNING_LOOP_PACKETS,
        learningLoopData: data,
    }
}

const requestNotExportedLearningLoopPacketsCount = () => {
    return {
        type: REQUEST_NOT_EXPORTED_LEARNING_LOOP_PACKETS_COUNT,
    }
}

const receiveNotExportedLearningLoopPacketsCount = (data) => {
    return {
        type: RECEIVE_NOT_EXPORTED_LEARNING_LOOP_PACKETS_COUNT,
        notExportedPacketsCount: data,
    }
}

const receiveGeneral = () => {
    return {
        type: RECEIVE_GENERAL,
    }
}

const clearState = () => {
    return {
        type: CLEAR_STATE,
    }
}

const askForPassword = () => {
    return {
        type: ASK_FOR_PASSWORD,
    }
}

export const reexportLLPacket = (fault, external) => {
    const apiPoint = external ? Airtime : LearningLoopApi
    if (isClosedState(fault.details.faultConditionState)) {
        return apiPoint.reexportLearningLoopPacket(fault.faultId, fault.assetId)
    }
    return false;
}
